<template>
        <div class="chklist">
          <dl>
            <dt>모아보기 :</dt>
            <dd>
              <input type="radio" name="index" v-model="$store.state.usRecordSettings.chkIndex" value="ALL" id="chk1011">
              <label for="chk1011">전체</label>
              <input type="radio" name="index" v-model="$store.state.usRecordSettings.chkIndex" value="DOW" id="chk1012">
              <label for="chk1012">다우30</label>
              <input type="radio" name="index" v-model="$store.state.usRecordSettings.chkIndex" value="NDX" id="chk1013">
              <label for="chk1013">나스닥100</label>
              <input type="radio" name="index" v-model="$store.state.usRecordSettings.chkIndex" value="SP" id="chk1014">
              <label for="chk1014">S&P500</label>
            </dd>
            <!-- //모아보기 -->
          </dl>
        </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['getUsRecordSettings'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/pc/common/WhrSearch.vue